import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { colors } from '../../../../../constants/colors';
import Alert from '../../../../../components/SolvPatternLibrary/Icons/Alert';
import { FadeIn } from '../../../../../core/util/commonCssAnimations';
import { dateHasOpenHours } from '../../../../../core/util/location';
import { getRelativeDayName } from '../../../../../core/util/date';
import { hasSlotsAvailable } from '../../../../../core/location/slots';

const StyledAlert = styled(Alert)`
  font-size: 18px;
  padding-top: 1px;
  margin-right: 2px;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
`;

const Title = styled.div`
  color: ${colors.ladyInRed};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: -0.27px;
  line-height: 18px;
`;

const Text = styled.div`
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: -0.25px;
  line-height: 20px;
  text-align: center;
`;

const Container = styled.div`
  animation: ${FadeIn} 300ms linear;
  padding-left: 5%;
  padding-right: 5%;
`;

class ClinicClosed extends PureComponent {
  shouldShowRecommendation = () =>
    // Only show second part of the copy if tomorrow (nextDate) has open hours and
    // has available slots
    dateHasOpenHours(this.props.location, this.props.nextDate) &&
    hasSlotsAvailable(this.props.nextDateSlots);

  render() {
    const {
      selectedDate,
      nextDate,
      location: { timezone },
    } = this.props;

    this.dayString = getRelativeDayName(selectedDate, timezone).toLowerCase();
    this.nextDayString = getRelativeDayName(nextDate, timezone).toLowerCase();

    return (
      <Container>
        <TitleContainer>
          <StyledAlert />
          <Title>Clinic Closed</Title>
        </TitleContainer>
        <Text>
          This clinic is closed {this.dayString}.
          {this.shouldShowRecommendation() && (
            <Fragment>
              <br />
              You can still book a visit for {this.nextDayString}.
            </Fragment>
          )}
        </Text>
      </Container>
    );
  }
}

ClinicClosed.propTypes = {
  selectedDate: PropTypes.object,
  nextDate: PropTypes.object,
  location: PropTypes.object,
  nextDateSlots: PropTypes.array,
};

export default ClinicClosed;
